export enum StatusCode
    {
        Draft = 0,
        Pending = 1,
        Active = 2,
        Inactive = 3,
        Cancelled = 4,
        Rejected = 5,
        Expired = 6
    }

export enum PaymentStatusCode
    {
        Draft = 0,
        Pending = 1,
        Granted = 2,
        NotGranted = 3,
        Received = 4,
        Refund = 5,
        CancelledByInitiateMoneyOut = 6,
        CancelledByConfirmMoneyOut = 7,
        Treated = 8,
        Deleted = 9,
        Hide = 10
    }

export enum IdentificationStatusCodes
    {
        Created = 0,
        Rejected = 1,
        Identified = 2,
        Error = 3
    }

export enum TransactionStatus
    {
        Success = 1,
        Pending = 2,
        Cancelled = 3,
        Refund = 4,
        Hide = 5
    }

export enum PaymentStatusCodeFromFINOP {
    ToPay = '000001',
    Paid = '000002',
    Inprogress = '000003',
    Failed = '000004',
    Error = "1" //Added to handle error Scenario
}
